module.exports = __webpack_public_path__ + "static/media/users.b92db382.svg";